import { mkTrackAttrs } from '@/analytics/track';

export const THREAD_FEEDBACK_PREFIX = 'thread_feedback';
export const MESSAGE_FEEDBACK_PREFIX = 'message_feedback';
export const REPORT_SECTION_FEEDBACK_PREFIX = 'report_section_feedback';
export const REPORT_TABLE_FEEDBACK_PREFIX = 'report_table_feedback';
export const PAPER_FINDER_FEEDBACK_PREFIX = 'paper_finder_feedback';

// Thumbs Up Button
export const mkThumbsUpBtnTrackAttrs = (
  prefix: string,
  props?: Record<string, any>,
) => mkTrackAttrs(`${prefix}__thumbs_up_btn`, props);

// Thumbs Down Button
export const mkThumbsDownBtnTrackAttrs = (
  prefix: string,
  props?: Record<string, any>,
) => mkTrackAttrs(`${prefix}__thumbs_down_btn`, props);

// Text Feedback Button
export const mkTextFeedbackBtnTrackAttrs = (
  prefix: string,
  props?: Record<string, any>,
) => mkTrackAttrs(`${prefix}__text_feedback_btn`, props);

// Text Feedback Box
export const mkTextFeedbackBoxTrackAttrs = (
  prefix: string,
  props?: Record<string, any>,
) => mkTrackAttrs(`${prefix}__text_box`, props);

// Close Button
export const mkCloseBtnTrackAttrs = (
  prefix: string,
  props?: Record<string, any>,
) => mkTrackAttrs(`${prefix}__close_btn`, props);

// Send Button
export const mkSendBtnTrackAttrs = (
  prefix: string,
  props?: Record<string, any>,
) => mkTrackAttrs(`${prefix}__send_btn`, props);
